import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import { AdBannerResponsive } from '../components/GoogleAdsense';
import ProductCarousel from '../components/affiliate/ProductCarousel';
import '../styles/pages/SpecialCommercialLawPage.css';

const SpecialCommercialLawPage = () => {
  useEffect(() => {
    document.title = '特定商取引法に基づく表記 | つむぎ';
  }, []);

  return (
    <AppLayout>
      <PageTitle
        title="特定商取引法に基づく表記"
        subtitle="Specified Commercial Transaction Act"
        icon="📋"
      />

      <div className="tsumugi-container py-6">
        <div className="tsumugi-card">
          <div className="commercial-law-content-wrapper">
            <p className="commercial-law-last-updated">
              最終更新日: 2026年1月
            </p>

            {/* 販売業者 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                販売業者
              </h2>
              <p className="commercial-law-text">
                PinkRose
              </p>
            </section>

            {/* 運営責任者 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                運営責任者
              </h2>
              <p className="commercial-law-text">
                松山義征
              </p>
            </section>

            {/* 所在地 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                所在地
              </h2>
              <p className="commercial-law-text">
                〒106-0044<br />
                東京都港区東麻布2-35-1 KCビル6F
              </p>
              <p className="commercial-law-hint-text-mt">
                ※お客様対応はメールおよびサービス内チャットにて承っております
              </p>
            </section>

            {/* 連絡先 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                連絡先
              </h2>
              <p className="commercial-law-text-mb">
                <strong>メールアドレス：</strong>hashimoto@pink-rose.info
              </p>
              <p className="commercial-law-hint-text">
                ※お問い合わせはメールまたはサービス内チャット機能にて24時間受付しております。<br />
                通常24時間以内に回答いたします。
              </p>
            </section>

            {/* 販売商品・サービス */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                販売商品・サービス
              </h2>
              <p className="commercial-law-text-mb-large">
                <strong>つむぎ - 橋本病の方のための寄り添いサービス</strong>
              </p>
              <ul className="commercial-law-list">
                <li>つむぎチャット（寄り添い会話）</li>
                <li>栄養相談</li>
                <li>レシピ提案（冷蔵庫写真から、食材入力から）</li>
                <li>成分表チェック</li>
                <li>血液検査サポート（Standard以上）</li>
                <li>気分記録・体調管理</li>
                <li>レシピ保存機能</li>
              </ul>
            </section>

            {/* 料金・プラン */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                料金・プラン
              </h2>

              <div className="commercial-law-plan-card">
                <p className="commercial-law-plan-title">
                  Freeプラン：0円/月
                </p>
                <ul className="commercial-law-plan-list">
                  <li>月間50ポイント付与</li>
                  <li>基本的なチャット・栄養相談</li>
                  <li>レシピ閲覧・保存機能</li>
                  <li>気分記録機能</li>
                </ul>
              </div>

              <div className="commercial-law-plan-card">
                <p className="commercial-law-plan-title">
                  Standardプラン：480円/月（税込）
                </p>
                <ul className="commercial-law-plan-list">
                  <li>月間900ポイント付与</li>
                  <li>より詳細な栄養相談</li>
                  <li>レシピ提案機能</li>
                </ul>
              </div>

              <div className="commercial-law-plan-card-premium">
                <p className="commercial-law-plan-title">
                  Premiumプラン：980円/月（税込）
                </p>
                <ul className="commercial-law-plan-list">
                  <li>月間1,800ポイント付与</li>
                  <li>すべての基本機能</li>
                  <li>成分表チェック</li>
                  <li>優先サポート</li>
                </ul>
              </div>

              <div className="commercial-law-plan-card-premium">
                <p className="commercial-law-plan-title">
                  Premium Plusプラン：1,980円/月（税込）
                </p>
                <ul className="commercial-law-plan-list">
                  <li>月間3,600ポイント付与</li>
                  <li>すべてのPremium機能</li>
                  <li>血液検査サポート</li>
                </ul>
              </div>

              <div className="commercial-law-plan-card-premium">
                <p className="commercial-law-plan-title">
                  Ultimateプラン：2,980円/月（税込）
                </p>
                <ul className="commercial-law-plan-list">
                  <li>月間5,500ポイント付与</li>
                  <li>すべての機能を制限なく利用可能</li>
                </ul>
              </div>
            </section>

            <AdBannerResponsive />

            {/* 支払方法 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                お支払い方法
              </h2>
              <p className="commercial-law-text-mb">
                クレジットカード決済（PAY.JP経由）
              </p>
              <p className="commercial-law-hint-text">
                対応カード：VISA、Mastercard、JCB、American Express、Diners Club
              </p>
            </section>

            {/* 支払時期 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                お支払い時期
              </h2>
              <p className="commercial-law-text">
                月額プランの場合：毎月の契約更新日に自動決済<br />
                初回は契約確定時に即時決済されます。
              </p>
            </section>

            {/* サービス提供時期 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                サービス提供時期
              </h2>
              <p className="commercial-law-text">
                お支払い確認後、即時サービス利用開始
              </p>
            </section>

            {/* 解約・退会 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                解約・退会について
              </h2>

              <h3 className="commercial-law-subsection-heading">
                解約について
              </h3>
              <p className="commercial-law-text-mb">
                マイページより、いつでも解約手続きが可能です。
              </p>
              <ul className="commercial-law-list-mb">
                <li>解約手続き完了後、次回更新日以降はサービス停止</li>
                <li>解約手続き日から次回更新日まではサービス利用可能</li>
                <li>解約手数料は一切かかりません</li>
              </ul>

              <h3 className="commercial-law-subsection-heading">
                退会について
              </h3>
              <ul className="commercial-law-list">
                <li>アカウント削除により、全データが完全削除されます</li>
                <li>この操作は取り消すことができませんのでご注意ください</li>
              </ul>
            </section>

            {/* 返金・キャンセル */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                返金・キャンセルについて
              </h2>
              <p className="commercial-law-text-bold">
                返金・キャンセルはお受けできません。
              </p>
              <p className="commercial-law-text">
                デジタルサービスの性質上、一度お支払いいただいた料金の返金には対応しておりません。ご購入前に、サービス内容・プラン内容を十分ご確認ください。
              </p>
            </section>

            {/* 免責事項 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                免責事項
              </h2>
              <div className="commercial-law-warning-box">
                <p className="commercial-law-warning-title">
                  重要なお知らせ
                </p>
                <ul className="commercial-law-list">
                  <li>本サービスは医療行為ではありません</li>
                  <li>寄り添い・栄養に関する情報提供のみを行います</li>
                  <li>診断・治療が必要な場合は、必ず医療機関を受診してください</li>
                  <li>血液検査結果の医学的解釈は医師にご確認ください</li>
                  <li>当サービスの利用により生じた損害について、当事業者は一切責任を負いません</li>
                </ul>
              </div>
            </section>

            {/* 個人情報の取扱い */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                個人情報の取扱い
              </h2>
              <p className="commercial-law-text">
                お客様の個人情報については、当サイトの
                <Link to="/privacy" className="commercial-law-link">
                  プライバシーポリシー
                </Link>
                に従って適切に管理・保護いたします。
              </p>
            </section>

            {/* 表記の変更 */}
            <section className="commercial-law-section">
              <h2 className="commercial-law-section-heading">
                表記内容の変更について
              </h2>
              <p className="commercial-law-text">
                本表記の内容は、法令の変更やサービス内容の変更に伴い、予告なく変更する場合があります。<br />
                最新の情報は当ページにてご確認ください。
              </p>
            </section>

            <p className="commercial-law-footer">
              以上
            </p>
          </div>
        </div>
        <AdBannerResponsive />
        <ProductCarousel location="commercial-law" />
      </div>
    </AppLayout>
  );
};

export default SpecialCommercialLawPage;
